export class DatumModel {
	id: number;
	created_at: string;
	updated_at: string;
	name: string;
	cohort_data_format: JSON;
}
